import gql from "graphql-tag"

const storesByInstanceQuery = gql`
  query StoresByInstanceQuery($instanceId: ID) {
    stores(instance: $instanceId) {
      edges {
        node {
          id
          name
          address
          phoneNumbers
          email
          latitude
          longitude
          website
          city {
            id
            name
            country {
              id
              name
            }
          }
        }
      }
    }
  }
`

export default storesByInstanceQuery
